import React from 'react';
import { useSelector } from 'react-redux';
import Team from './Team';
import './TeamList.css';
import ColorLegend from '../planning/ColorLegend';
import * as ResourceStore from '../../store/ResourceStore';
import moment from 'moment';

const CustomTeamList = () => {
    const units = useSelector((state) => state[ResourceStore.reducerName].units); 
    const bookings = useSelector((state) => state[ResourceStore.reducerName].bookings);
    const teams = useSelector((state) => state.teamState.teams);

    const now = moment();
    const currentBookings = bookings.filter((x) => now.isSameOrAfter(moment(x.startTime)) && now.isSameOrBefore(moment(x.endTime)));

    if (teams.length < 1) return null;

    const addUnits = (team) => {
        if (!team) return;
        const unitsForTeam = currentBookings.reduce((result, b) => {
            if (b.teamId === team.id) {
                const unit = units.find((u) => u.id === b.unitId);
                if (unit) result.push(unit);
            }
            return result;
        }, []);
        return { ...team, units: unitsForTeam };
    };

    // const teamsToShow = props.teams;

    // teamsToShow.forEach(team => {
    //     team.team = teams.find(x => x.id === team.id);
    // });

    // // Vi har umiddelbart ikke brug for at tilføje units her - men hvis vi får brug for det, skal det gøres på hvert team
    // //addUnits(administration);
    // //addUnits(pladsen);

    // const showTeam = (team) => {
    //     return team.team && <Team key={team.team.id} team={team.team} width={team.width || 100/teamsToShow.length}/>;
    // };


    // return (
    //     <div key={key} className="team-list" style={{ paddingRight: `${currentPadding}%`}}>
    //         {teamsToShow.map(team => showTeam(team))}
    //     </div>
    // );


    const stab = teams.find(x => x.id === 125);
    const nytteJobberne = teams.find(x => x.id === 127);
    const vaerkstedet = teams.find(x => x.id === 128);
    const naturVandOgVej = teams.find(x => x.id === 126);
    const grønDriftOgIdraet = teams.find(x => x.id === 129);
   
    addUnits(stab);
    addUnits(nytteJobberne);
    addUnits(vaerkstedet);
    addUnits(naturVandOgVej);
    addUnits(grønDriftOgIdraet);

    return (
        <div className="team-list">
            {stab &&
                <Team
                    team={stab}
                    width={15}
                    subTeams={[]}

                />
            }
            {nytteJobberne &&
                <Team
                    team={nytteJobberne}
                    width={15}
                    subTeams={[]}

                />
            }
            {vaerkstedet &&
                <Team
                    team={vaerkstedet}
                    width={15}
                    subTeams={[]}

                />
            }
            {naturVandOgVej &&
                <Team
                    team={naturVandOgVej}
                    width={27.5}
                    subTeams={[]}
                />
            }
            {grønDriftOgIdraet &&
                <Team
                    team={grønDriftOgIdraet}
                    width={27.5}
                    subTeams={[]}
                />
            }
            <ColorLegend />
        </div>
    );

};

export default CustomTeamList;